/**
 * Util file exclusively used for the payment front part
 */

const BILHoldersUtil = {

    /**
    * Logical method for converting accounts returned from the Cash-Account to the data structure expected by the front payment
    */
   MSCashDtoToBILHoldersListDto(MSCashDto) {
        var sortedHolderList = []
        var ownershipTypeList = []
        var BILHoldersListDto = []

        /** 1. Temporary filter to get only accounts that are HOLDER or AGENT and which have simple digital signature rights + NO read only access */
        MSCashDto = MSCashDto.filter((account) => {
            if (account.disposalRights.digitalReadOnly || account.disposalRights.digitalSignatureRights !== 'Single') {
                return false
            }
            return true
        })

        /** 2. Process to sort all "ownershipType" in order to have a specific order */
        var ownershipTypeOrder = {"HOLDER":1, "AGENT":2, "LEGAL":3};
        MSCashDto.sort(function(a,b) { return ownershipTypeOrder[a.ownershipType] - ownershipTypeOrder[b.ownershipType]; })

        /** 3. Process to sort all "HolderList" returned from the Cash-Account in case the zID are not returned in the same order for a same holder group */
        MSCashDto.forEach((account) => {
            account.holderList.sort((a, b) => (a.partyId > b.partyId) ? 1 : -1)
        })

        /** 4. Process to retrieve all sorted "HolderList" array in a new intermediate array */
        MSCashDto.forEach((account) => {
            sortedHolderList.push(account.holderList)
        })

        /** 5. Filter to get all UNIQUE holderList returned from the Cash-Account  */
        const uniqueSortedHolderList = sortedHolderList.filter((thing, index) => {
            const _thing = JSON.stringify(thing);
            return index === sortedHolderList.findIndex(obj => {
                return JSON.stringify(obj) === _thing;
            })
        })

        /** 6. As we know the number of groups of holder that will displayed, for each of them we push the "HolderList" array in a new object with an adequate data structure */
        uniqueSortedHolderList.forEach((arr) => {
            BILHoldersListDto.push({
                "holderNames": [],
                "accounts": [],
                "holderList": arr,
                "ownershipType": null
            })
        })

        /** 7. Now for each accounts from the Cash-Account we compare each "HolderList" array with the new data object created previously and
               when they match between them we add the account and the ownershipType to the new data object */
        MSCashDto.forEach((account) => {
            BILHoldersListDto.forEach((BILHoldersDto) => {
                if (JSON.stringify(BILHoldersDto.holderList) === JSON.stringify(account.holderList)) {
                    BILHoldersDto.accounts.push({
                        "label": !isEmpty(account.customLabel) ? account.customLabel :
                                 !isEmpty(account.label) ? account.label :
                                 "CURRENT ACCOUNT",
                        "iban": account.iban,
                        "balance": account.balance,
                        "counterValue": account.counterValue,
                        "currency": account.currency,
                    })
                    BILHoldersDto.ownershipType = account.ownershipType
                }
                /** 7b. Process in order to collect all type of account ownershipType for an easier display on the front */
                if (ownershipTypeList.indexOf(account.ownershipType) === -1) {
                    ownershipTypeList.push(account.ownershipType)
                }
            })
        })

        /** 8. Process in order to parse each "HolderList" informations for an easier display on the front */
        BILHoldersListDto.forEach((BILHoldersDto) => {
            BILHoldersDto.holderList.forEach((holder) => {
                var fullName = ""
                var title = ""
                var partyId = holder.partyId

                if (holder.personType === "LEGAL") {
                    if (!isEmpty(holder.corporateAcronym)) {
                        fullName = holder.corporateAcronym
                    } else if (!isEmpty(holder.corporateName)) {
                        fullName = holder.corporateAcronym
                    } else {
                        fullName = "NOT AVAILABLE"
                    }
                } else if (holder.personType === "NATURAL") {
                    if (isEmpty(holder.firstName) && isEmpty(holder.lastName)) {
                        fullName = "NOT AVAILABLE"
                    } else {
                        if (!isEmpty(holder.title)) {
                            title = holder.title + " "
                        }
                        if (isEmpty(holder.firstName)) {
                            fullName = title + holder.lastName
                        } else if (isEmpty(holder.lastName)) {
                            fullName = title + holder.firstName
                        } else {
                            fullName = title + holder.firstName + " " + holder.lastName
                        }
                    }
                } else {
                    fullName = "NOT AVAILABLE"
                }
                if (isEmpty(partyId)) {
                    partyId = "NOT AVAILABLE"
                }
                
                BILHoldersDto.holderNames.push({fullName: fullName, partyId: partyId})
            })
        })
        return { BILHoldersListDto, ownershipTypeList }
    },

    /**
    * Method used to convert the role from the Cash-Account to the front payment
    */
    toFrontRole(ownershipType) {
        switch (ownershipType) {
            case "LEGAL":
                return "professional"
            case "AGENT":
                return "naturalPerson"
            default :
                return "holder"
        }
    },

    /**
    * Method used to reorganize the accounts holders item's borders
    */
    reorganizeBorder() {
        var ownershipTypes = ["HOLDER", "AGENT", "LEGAL"]
        ownershipTypes.forEach((type) => {
            var typeElem = document.getElementsByName(type)
            typeElem.forEach((account, index) => {

                // Border radius
                if (typeElem.length > 1 && !(index === typeElem.length - 1)) {
                    account.style.borderBottomLeftRadius = '0px'
                    account.style.borderBottomRightRadius = '0px'
                }
                if (typeElem.length > 1 && index !== 0) {
                    account.style.borderTopLeftRadius = '0px'
                    account.style.borderTopRightRadius = '0px'
                }

                // Border
                if ( (index >= 0 && typeElem.length - 1 !== 0) && !(index === typeElem.length - 1)) {
                    account.style.borderBottom = 'none'
                }
            })
        })
    },

    /**
    * Method used to mock data from cash-account with the new data structure object
    * 
    */
    mockAccounts() {
        return [
        {
            label: "COMPTE COURANT",
            customLabel: "TEST LABEL",
            iban: "LU82 8521 6981 4201 0014",
            balance: 34.00,
            currency: "EUR",
            holderList: [
                {
                    
                    corporateAcronym: null,
                    corporateName: null,
                    corporateStructure: null,
                    firstName: "FREDERIC",
                    lastName: "DOLPHEN",
                    partyId: "Z7856956",
                    personType: "NATURAL",
                    title: "MR."

                }
            ],
            ownershipType: "AGENT",
            disposalRights: {
                digitalReadOnly: false,
                digitalSignatureRights: "Single"
            }
        },
        {
            label: "COMPTE COURANT",
            iban: "LU82 5521 7845 6598 2340",
            balance: -34.00,
            currency: "EUR",
            holderList: [
                {
                    corporateAcronym: null,
                    corporateName: null,
                    corporateStructure: null,
                    firstName: "KARIM",
                    lastName: "COLABELLI",
                    partyId: "Z1452363",
                    personType: "NATURAL",
                    title: "MR."
                },
                {
                    corporateAcronym: null,
                    corporateName: null,
                    corporateStructure: null,
                    firstName: "THIERRY",
                    lastName: "HERMANN",
                    partyId: "Z6214574",
                    personType: "NATURAL",
                    title: "MR."
                },
            ],
            ownershipType: "AGENT",
            disposalRights: {
                digitalReadOnly: false,
                digitalSignatureRights: "Single"
            }
        },
        {
            label: "COMPTE COURANT",
            iban: "LU82 1245 3256 8854 2294",
            balance: -34.00,
            currency: "EUR",
            holderList: [
                {
                    corporateAcronym: null,
                    corporateName: null,
                    corporateStructure: null,
                    firstName: "THOMAS",
                    lastName: "HUARD",
                    partyId: "Z8574172",
                    personType: "NATURAL",
                    title: "MR."
                }
            ],
            ownershipType: "AGENT",
            disposalRights: {
                digitalReadOnly: false,
                digitalSignatureRights: "Single"
            }
        },
        {
            label: "COMPTE COURANT",
            iban: "LU82 1124 3652 8745 4475",
            balance: 34.00,
            currency: "EUR",
            holderList: [
                {
                    corporateStructure: "SA",
                    corporateAcronym: "HORIZON CAPITAL FINANCIAL SA R",
                    corporateName: "HORIZON CAPITAL FINANCIAL SA R L - SECURITIZATION - HORIZON -HORIZON CAPITAL FINANCIAL SA R",
                    firstName: null,
                    lastName: null,
                    partyId: "Z1452355",
                    personType: "LEGAL",
                    title: null
                }
            ],
            ownershipType: "LEGAL",
            disposalRights: {
                digitalReadOnly: false,
                digitalSignatureRights: "Single"
            }
        },
        {
            label: "COMPTE COURANT",
            iban: "LU82 0102 3120 4240 7890",
            balance: 0.00,
            currency: "EUR",
            holderList: [
                {
                    corporateAcronym: null,
                    corporateName: null,
                    corporateStructure: null,
                    firstName: "KARIM",
                    lastName: "COLABELLI",
                    partyId: "Z1452363",
                    personType: "NATURAL",
                    title: "MR."
                }
            ],
            ownershipType: "HOLDER",
            disposalRights: {
                digitalReadOnly: false,
                digitalSignatureRights: "Single"
            }
        }]
    }

}

function isEmpty(str) {
    return (!str || 0 === str.length);
}

export default BILHoldersUtil